<template>
  <div id="SectionManufacturingHero">
    <UIContainer class="SectionManufacturingHero__container">
      <template #left>
        <!-- Main Headline -->
        <SectionTitle titleTag="h1">
          <template #title>
            Reduce manufacturing emissions by 40% while cutting compliance costs
          </template>
        </SectionTitle>

        <!-- Description -->
        <p class="SectionManufacturingHero__description">
          Turn plant reality into assurance-ready carbon numbers... Be ready for
          customer audits and CBAM requests without month-long reconciliations.
        </p>

        <!-- Social Proof -->
        <div class="SectionManufacturingHero__social-proof">
          <SectionSocialProof />
        </div>

        <!-- CTA Button -->
        <div class="SectionManufacturingHero__cta">
          <UIButton size="xl" theme="primary" :to="{ name: 'Contact' }">
            Book a demo
          </UIButton>
        </div>
      </template>

      <template #right>
        <div class="SectionManufacturingHero__image-container">
          <img
            class="SectionManufacturingHero__image"
            src="../assets/hero/bg.avif"
            alt="Net zero hero background"
            fetchpriority="high"
            loading="eager"
          />
        </div>
      </template>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import UIButton from '@/views/components/ui/buttons/UIButton.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import SectionSocialProof from '@/views/components/sections/SectionSocialProof.vue'
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
</script>

<style lang="scss" scoped>
#SectionManufacturingHero {
  .SectionManufacturingHero__container {
    padding: 2rem 2rem 3rem;
    position: relative;

    @include md {
      padding: 2.875rem 3rem 6rem;
    }
  }

  .SectionManufacturingHero__image-container {
    display: none;
    position: relative;

    @include md {
      display: block;
    }
  }

  .SectionManufacturingHero__image {
    width: 100%;
  }

  .SectionManufacturingHero__trust-icon {
    --size: 1rem;
    --color: #{$newcolor-primary-main};
  }

  .SectionManufacturingHero__title-highlight {
    background: linear-gradient(45deg, #023025 0%, #04785e 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
  }

  .SectionManufacturingHero__description {
    @include font-size-18px();
    color: $color-ui-gray-cool-600;
    line-height: 1.6;
    margin-bottom: 2rem;
    margin-top: 1.5rem;
    max-width: 32rem;

    strong {
      font-weight: 600;
      color: $color-ui-gray-cool-900;
    }
  }

  .SectionManufacturingHero__social-proof {
    margin-bottom: 2rem;
  }

  .SectionManufacturingHero__cta {
    display: flex;
    align-items: center;
    justify-content: center;

    @include md {
      justify-content: flex-start;
    }
  }
}
</style>
